export function degreeToRadians(degrees: number) {
  return (degrees * Math.PI) / 180;
}

// Helper function to clamp a value between a min and max
export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

export function rotatePoint(point: [number, number], center: [number, number], angleInRadians: number): [number, number] {
  const [x, y] = point;
  const [cx, cy] = center;

  const rotatedX = Math.cos(angleInRadians) * (x - cx) - Math.sin(angleInRadians) * (y - cy) + cx;
  const rotatedY = Math.sin(angleInRadians) * (x - cx) + Math.cos(angleInRadians) * (y - cy) + cy;

  return [rotatedX, rotatedY];
}

export function round(value: number, decimals: number) {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
}
